export default {
    title: {
        long: '后台管理系统',
        short: '系统',
    },
    login: {
        title: '用户 登录',
        btn: '登 录',
        username: '用户名',
        password: '密码',
    },
    logout: {
        logout: '退 出',
        space: '个人中心'
    },
    menu: {
        '/': '首页',
        home: '首页',
        mall: '商品',
        user: '用户列表',
        '其他': '其他',
        page1: '页面1',
        page2: '页面2',
    },
    driver: {
        doneBtnText: '完成',
        closeBtnText: '关闭',
        nextBtnText: '下一步',
        prevBtnText: '上一步',
        guideBtn: '引导按钮',
        hamburgerBtn: '汉堡按钮',
        langBtn: '中英文切换'
    },

}